import { render, staticRenderFns } from "./CrossQuoteTable.vue?vue&type=template&id=0a9702ec&scoped=true"
import script from "./CrossQuoteTable.vue?vue&type=script&lang=js"
export * from "./CrossQuoteTable.vue?vue&type=script&lang=js"
import style0 from "./CrossQuoteTable.vue?vue&type=style&index=0&id=0a9702ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9702ec",
  null
  
)

export default component.exports